(() => {
  function getProductData() {
    const el = document.querySelector("[data-product-json]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn("[PriceSync] Failed to parse product JSON", e);
      return null;
    }
  }

  function getVariantId() {
    // 1) URL variant param (best signal)
    const urlId = new URLSearchParams(window.location.search).get("variant");
    if (urlId) return String(urlId);

    // 2) Hidden add-to-cart input (fallback)
    const inputId = document.querySelector("form[action*='/cart/add'] input[name='id']")?.value;
    return inputId ? String(inputId) : null;
  }

  function findVariant(productData, variantId) {
    if (!productData || !variantId) return null;
    return productData.variants.find(v => String(v.id) === String(variantId)) || null;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format((cents || 0) / 100);
  }

  function paintPrice(variant) {
    const priceText = formatMoney(variant.price);

    // Elixir / your template uses these
    document.querySelectorAll(".shop-product-price-block").forEach(el => (el.textContent = priceText));
    document.querySelectorAll(".shop-product-price").forEach(el => (el.textContent = priceText));
    document.querySelectorAll("[data-product-price]").forEach(el => (el.textContent = priceText));
  }

  function syncPrice(productData) {
    const variantId = getVariantId();
    const variant = findVariant(productData, variantId);
    if (!variant) return;

    paintPrice(variant);
  }

  function hookHistory(productData) {
    const _replaceState = history.replaceState;
    history.replaceState = function () {
      _replaceState.apply(this, arguments);
      syncPrice(productData);
    };

    const _pushState = history.pushState;
    history.pushState = function () {
      _pushState.apply(this, arguments);
      syncPrice(productData);
    };

    window.addEventListener("popstate", () => syncPrice(productData));
  }

  document.addEventListener("DOMContentLoaded", () => {
    const productData = getProductData();
    if (!productData) {
      console.warn("[PriceSync] No [data-product-json] found.");
      return;
    }

    // Initial
    syncPrice(productData);

    // When Elixir updates URL/form via its own JS, we follow along
    hookHistory(productData);

    // Also respond to changes/clicks in the product section (safe, doesn’t block anything)
    const root = document.querySelector(".shop-product-section") || document;
    root.addEventListener("change", () => setTimeout(() => syncPrice(productData), 30));
    root.addEventListener("click", () => setTimeout(() => syncPrice(productData), 30));

    // Catch hidden input changes if Elixir updates it silently
    const idInput = document.querySelector("form[action*='/cart/add'] input[name='id']");
    if (idInput) {
      let last = idInput.value;
      setInterval(() => {
        if (idInput.value !== last) {
          last = idInput.value;
          syncPrice(productData);
        }
      }, 150);
    }

    console.log("[PriceSync] Running ✅");
  });
})();
